import { JobDetail, JobDetailStep } from '../../store/workspace/types';
import { setJobDetailStep } from '../../store/workspace/slice';
import { AshbyLogoIcon, MenuBoardIcon } from '../../assets/icons/common';
import { useDispatch } from '../../store/store';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';
import Button from '../Button';

interface Props {
    tab?: string;
    CtaTitle?: string;
    jobDetail: JobDetail;
};

function JobCard(props: Props) {
    const {
        tab,
        CtaTitle,
        jobDetail: {
            id,
            city,
            state,
            title,
            country,
            jobType,
            platform,
            companyName,
            companyLogo,
            baseSalaryAmount,
            baseSalaryFrequency,
            multipleChoiceExamDeadline,
        },
    } = props;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getDeadline = () => {
        if (!multipleChoiceExamDeadline) return null;

        const [month, day, year] = multipleChoiceExamDeadline.split('-');
        const deadline = new Date(Number(year), Number(month) - 1, Number(day));
        const today = new Date();
        const diffTime = deadline.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays <= 10 && diffDays > 0
            ? <b data-text-color='red'>({`${diffDays} day${diffDays > 1 ? 's' : ''} left`})</b>
            : null
    };

    const startExam = (detailStep: JobDetailStep) => {
        dispatch(setJobDetailStep(detailStep));
        navigate(`/workspace/exams/${id}?tab=${tab}`)
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.company_detail}>
                    <div className={styles.company_detail_logo}>
                        {companyLogo ? <img src={companyLogo} alt="" /> : <span>{companyName?.slice(0, 1)}</span>}
                    </div>
                    <div className={styles.company_detail_name}>
                        <span>{companyName}</span>
                        {platform === 'Ashby' && <AshbyLogoIcon width={71} height={23} />}
                    </div>
                </div>
                {multipleChoiceExamDeadline &&
                    <div className={styles.deadline}>
                        <MenuBoardIcon />
                        <span>Deadline: </span>
                        <b>{multipleChoiceExamDeadline}</b>
                        {getDeadline()}
                    </div>}
            </div>
            <div className={styles.job_detail}>
                <div className={styles.row}>
                    <span className={styles.row_text} data-is-bold="true">{title}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.row_text}>Job type: {jobType.title}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.row_text}>
                        Base salary amount: {baseSalaryAmount || '---'}$ /{baseSalaryFrequency.title}
                    </span>
                </div>
                <div className={styles.row}>
                    <span className={styles.row_text}>
                        {city?.city} / {state?.state} / {country?.title}
                    </span>
                </div>
            </div>
            <div className={styles.actions}>
                <Button
                    type='Primary'
                    className={styles.actions_btn}
                    onClick={() => startExam('Rules')}
                    text={CtaTitle || 'Start multiple choice exam'}
                />
                <Button
                    type='Outline-Primary'
                    text='Job description'
                    className={styles.actions_btn}
                    onClick={() => startExam('JobDetail')}
                />
            </div>
        </div>
    )
};

export default JobCard;
